export default __webpack_public_path__ + "alberta-content.d7f63d8cdac9ecb3341a.svg";